let katexModulePromise: Promise<typeof import('katex')> | null = null

async function loadKatex() {
  if (!katexModulePromise) {
    katexModulePromise = (async () => {
      const [mod] = await Promise.all([import('katex'), import('katex/dist/katex.min.css')])
      return mod
    })()
  }
  return (await katexModulePromise).default
}

export async function renderLatexIn(root: ParentNode) {
  const inline = root.querySelectorAll<HTMLElement>('.math-inline')
  const display = root.querySelectorAll<HTMLElement>('.math-display')
  if (inline.length === 0 && display.length === 0) return

  const katex = await loadKatex()
  const render = (el: HTMLElement, displayMode: boolean) => {
    katex.render(el.textContent ?? '', el, {
      displayMode,
      throwOnError: false,
    })
  }
  inline.forEach((el) => render(el, false))
  display.forEach((el) => render(el, true))
}
